import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import KPICard from '../Common/KPICard';
import WorkQueueKPIsSkeleton from './Skeletons/WorkQueueKPIsSkeleton';

const workQueueKPIs = [
	{ label: 'Total open items', value: '—' },
	{ label: 'High priority', value: '—', valueColor: 'error.main' },
	{ label: 'Overdue', value: '—'},
	{ label: 'Completed this week', value: '—' },
];

const WorkQueueKPIs = ({ loading = false }) => {
	if (loading) {
		return <WorkQueueKPIsSkeleton />;
	}

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: {
					xs: 'repeat(2, minmax(0, 1fr))',
					md: 'repeat(4, minmax(0, 1fr))',
				},
				gap: '10px',
			}}
		>
			{workQueueKPIs.map((kpi) => (
				<KPICard key={kpi.label} {...kpi} />
			))}
		</Box>
	);
};

WorkQueueKPIs.propTypes = {
	loading: PropTypes.bool,
};

export default WorkQueueKPIs;
